import React, { useEffect, useRef, useState, useCallback } from "react";
import { observer } from "mobx-react-lite";
import { useSidebarCollapse } from "../../../contexts/SidebarCollapseContext";
import ClientCampaignsHeader from "./ClientCampaignsHeader";
import ClientSummaryTab from "./ClientSummaryTab";
import ClientTabPlaceholder from "./ClientTabPlaceholder";
import ClientTimelineTab from "./ClientTimelineTab";
import ClientCalendarTab from "./ClientCalendarTab";
import ClientShareModal from "./ClientShareModal";
import {
  clientPageInset,
  TOP_NAV_HEIGHT,
} from "./CampaignsBrowseParts/clientPageLayout";

export default observer(function ClientCampaignsPage() {
  const [activeTab, setActiveTab] = useState("summary");
  const [newCalendarEntryTick, setNewCalendarEntryTick] = useState(0);
  const { isCollapsed } = useSidebarCollapse();
  const contentRef = useRef(null);

  useEffect(() => {
    contentRef.current?.scrollTo(0, 0);
  }, [activeTab]);

  const triggerNewCalendarEntry = useCallback(
    () => setNewCalendarEntryTick((t) => t + 1),
    [],
  );

  useEffect(() => {
    setNewCalendarEntryTick(0);
  }, [activeTab]);

  return (
    <div
      className="fixed flex flex-col bg-rb-grey dark:bg-rb-dark-mode-background"
      style={{
        top: TOP_NAV_HEIGHT,
        left: clientPageInset(isCollapsed),
        right: 0,
        bottom: 0,
      }}
    >
      <ClientCampaignsHeader
        activeTab={activeTab}
        onTabChange={setActiveTab}
        onNewCalendarEntry={triggerNewCalendarEntry}
      />
      <div
        ref={contentRef}
        className="w-full flex-1 min-h-0 min-w-0 overflow-y-auto"
      >
        {activeTab === "summary" && <ClientSummaryTab />}
        {activeTab === "timeline" && <ClientTimelineTab />}
        {activeTab === "calendar" && (
          <ClientCalendarTab newEntryTick={newCalendarEntryTick} />
        )}
      </div>
      <ClientShareModal />
    </div>
  );
});
